import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import {finalize, Observable} from 'rxjs';
import {CustomLoadingService} from '../custom-loading-service';
import {Injectable} from '@angular/core';
import {tap} from 'rxjs/operators';

@Injectable()
export class RequestHttpInterceptor implements HttpInterceptor {
  constructor(public loaderService: CustomLoadingService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.increment();
    let cancelled = true;
    return next.handle(req).pipe(
      tap({
        next: (response) => {
          if (response instanceof HttpResponse) {
            this.loaderService.decrement();
            cancelled = false;
          }
        },
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            this.loaderService.decrement();
            cancelled = false;
          }
        },
        complete: () => {
          cancelled = false;
        }
      }),
      finalize(() => {
        if (cancelled) {
          this.loaderService.decrement();
        }
      })
    );
  }
}
